/* =====================================================================
 * Ja-Geldgeschenk-Poster Editor (PROJ-26) — Hochzeits-Geldgeschenk
 * =====================================================================
 * Reines Text/SVG-Poster (KEIN Foto, KEIN Crop, KEINE Map). Kopiervorlage
 * = wunschwort-poster.js (State/Live-Preview, Groessen-/Frame-Picker aus
 * target_product.variants, Cart-Add). Alles Foto-bezogene ist entfernt.
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderJaGeldgeschenk() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (gleiche Positionen,
 * cqw-Groessen, Herz-Geometrie, Auto-Fit). Aendert sich der Server, muss
 * dieser Block mitgezogen werden — Werte sind bewusst identisch gehalten.
 *
 * EDITOR-ONLY: Hinter dem Herz liegt eine Geldschein-Andeutung (SVG, auf die
 * Herzform geclippt), damit der Kaeufer versteht "da kommt Geld rein". Der an
 * den Server gesendete Payload enthaelt KEIN Geld — im Druck ist das Herz ein
 * leerer Umriss (Schnittlinie).
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.JG_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var BG = '#ffffff';
  var SERIF = "'Playfair Display', Georgia, serif";
  var SANS = "'Outfit', system-ui, sans-serif";
  var SCRIPT = "'parlare', 'Great Vibes', cursive";
  // Namen-Schrift-Stil (Definitionsposter-Muster: Modern/Elegant/Verspielt). Wirkt NUR
  // auf die Namen-Zeile; das grosse "Ja" bleibt fest (parlare). 1:1-Spiegel des Servers.
  var NAME_STYLES = {
    modern:    { font: "'clother', sans-serif",              weight: 700, upper: true,  spacing: '0.14em' },
    elegant:   { font: "'Playfair Display', Georgia, serif", weight: 600, upper: true,  spacing: '0.14em' },
    verspielt: { font: "'parlare', 'Great Vibes', cursive",  weight: 400, upper: false, spacing: '0.02em' }
  };
  // Herzform aus der Stadtkarte (citymap.liquid #photo-heart, viewBox 204.37 x 185) — organische, hochwertige Form.
  var JG_HEART_PATH = 'M197.19,79.91c-12.89,55.16-89.21,97.44-95,100.39-5.78-2.95-82.09-45.23-95-100.39-2.52-10.78-5.65-31.82,6.23-50.08,1.4-2.16,7.5-10.68,18.8-17.44C48.35,2.72,78.73-3.65,102.19,30.51,125.67-3.67,156.03,2.72,172.16,12.39c11.3,6.76,17.4,15.29,18.8,17.44,11.88,18.25,8.75,39.3,6.23,50.08Z';
  var JG_HEART_VB = '0 0 204.37 185';

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId, currentGrid;
  var state = {
    names: 'Emma & Ben',
    date: '',
    ort: '',
    spruch: '',
    untenzeile: '',
    word: 'Ja',
    cut_dash: false,
    bg_color: '#ffffff',
    name_style: 'elegant',
    c_names: '#28292d',
    c_meta: '#28292d',
    c_spruch: '#28292d',
    c_unten: '#28292d',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  /* ===================================================================
   * Render-Bausteine — 1:1-Spiegel von jgText/jgFit (Server print-mode.js)
   * =================================================================== */
  function jgText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';';
    if (o.wrap) { css += 'width:' + o.wrap + '%;white-space:normal;flex-direction:column;'; }
    else { css += 'white-space:nowrap;'; }
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  /* Schrumpft eine nowrap-Zeile, bis sie in maxPct% der Stage-Breite passt
     (nach Font-Load). Identisch zur Server-Funktion. */
  function jgFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* Grosses Herz (Ausschneide-Umriss, Stadtkarten-Herzform) NEBEN dem "Ja".
     1:1-Spiegel von renderJaGeldgeschenk (Server print-mode.js). WICHTIG:
     keine Linie auf/durch dem Herz (wird ausgeschnitten). EDITOR-Zusatz:
     Geldschein-Andeutung auf die Herzform geclippt (rein visuell, NICHT im Payload). */
  function buildHeart(dash) {
    var wrap = document.createElement('div');
    wrap.className = 'jg-heart';
    wrap.style.cssText = 'position:absolute;left:56%;top:33%;width:34%;z-index:4;';
    var clipId = 'jg-heart-clip-' + (sectionId || 'x');
    var dashAttr = dash ? ' stroke-dasharray="3 2.4"' : '';
    // Editor-Vorschau des Geldscheins im Herz (nur Editor, NICHT im Druck). Echtes
    // WebP-Foto statt grünem Platzhalter; Fallback = alter grüner Block, falls Asset fehlt.
    var moneyImg = (root && root.dataset && root.dataset.moneyImg) || '';
    var moneyFill = moneyImg
      ? '<image href="' + moneyImg + '" x="0" y="0" width="204.37" height="185" preserveAspectRatio="xMidYMid slice"/>'
      : '<rect x="0" y="0" width="204.37" height="185" fill="#d3e8cb"/>' +
        '<rect x="34" y="46" width="136" height="92" fill="none" stroke="#9cc294" stroke-width="2"/>' +
        '<text x="54" y="80" font-family="Georgia, serif" font-size="26" fill="#7fae76">50</text>' +
        '<text x="102" y="122" text-anchor="middle" font-family="Georgia, serif" font-size="60" fill="#6ea368">€</text>';
    wrap.innerHTML =
      '<svg viewBox="' + JG_HEART_VB + '" style="display:block;width:100%;height:auto;overflow:visible;">' +
        '<defs><clipPath id="' + clipId + '"><path d="' + JG_HEART_PATH + '"/></clipPath></defs>' +
        '<g clip-path="url(#' + clipId + ')">' +
          moneyFill +
        '</g>' +
        '<path d="' + JG_HEART_PATH + '" fill="none" stroke="' + INK + '" stroke-width="4.2"' + dashAttr + ' stroke-linejoin="round"/>' +
      '</svg>';
    return wrap;
  }

  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    // Namen-Schrift-Stil (nur die Namen; das "Ja" bleibt fest)
    var ns = NAME_STYLES[state.name_style] || NAME_STYLES.elegant;
    // Kopf: Namen (waehlbarer Stil, Auto-Fit 90%) — Farbe je Zeile (state.c_*)
    var elNames = jgText(grid, { content: state.names, x: 50, y: 12, font: ns.font, weight: ns.weight, size: 5.2, color: state.c_names || INK, upper: ns.upper, spacing: ns.spacing });
    // Meta: Datum + "   ·   " + Ort (leere weglassen), Auto-Fit 92%
    var meta = [state.date, state.ort].filter(function (s) { return s && String(s).trim(); }).join('   ·   ');
    var elMeta = jgText(grid, { content: meta, x: 50, y: 18.5, font: SANS, weight: 500, size: 2.6, color: state.c_meta || INK, upper: true, spacing: '0.24em' });

    // Grosses Herz NEBEN dem "Ja" (+ Geldschein-Andeutung, nur Editor). Herz bleibt INK (Schnittlinie).
    grid.appendChild(buildHeart(state.cut_dash));

    // Grosses Script-Wort ("Ja") — bleibt fest parlare + INK (kein Style/keine Farbe).
    // HINTER das Herz legen (z-index unter dem Herz=4): der "a"-Schwung laeuft hinter der
    // Geld-Flaeche durch, nicht darueber. 1:1-Spiegel des Servers.
    var elWord = jgText(grid, { content: state.word || 'Ja', x: 34, y: 46, font: SCRIPT, weight: 400, size: 25, color: INK, lh: 1 });
    if (elWord) elWord.style.zIndex = 3;
    // Mittel-Spruch (umbrechend, kein Fit)
    jgText(grid, { content: state.spruch, x: 62, y: 63, font: SANS, weight: 500, size: 2.3, color: state.c_spruch || INK, upper: true, spacing: '0.16em', wrap: 42, lh: 1.5 });
    // Unten-Zeile, Auto-Fit 92%
    var elUnten = jgText(grid, { content: state.untenzeile, x: 50, y: 89, font: SANS, weight: 600, size: 2.7, color: state.c_unten || INK, upper: true, spacing: '0.16em' });

    stage.innerHTML = '';
    stage.appendChild(grid);
    currentGrid = grid;

    // Auto-Fit — Grid ist im DOM, stage.clientWidth verfuegbar
    jgFit(elNames, 90);
    jgFit(elMeta, 92);
    jgFit(elWord, 74);
    jgFit(elUnten, 92);
  }

  /* ===================================================================
   * Text-Felder + Preset-Chips + Schnittlinien-Toggle
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }
  function bindInputs() {
    bindField('input-namen', 'names');
    bindField('input-datum', 'date');
    bindField('input-ort', 'ort');
    bindField('input-spruch', 'spruch');
    bindField('input-untenzeile', 'untenzeile');
  }
  function initPresetChips() {
    var chips = root.querySelectorAll('.jg-preset-chips [data-preset]');
    var spruchInput = document.getElementById('input-spruch');
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var val = c.getAttribute('data-preset') || '';
        if (spruchInput) spruchInput.value = val;
        state.spruch = val;
        render();
      });
    });
  }
  function initDashToggle() {
    var cb = document.getElementById('jg-dash-toggle');
    if (!cb) return;
    cb.addEventListener('change', function () { state.cut_dash = cb.checked; render(); });
  }

  /* Inline-Textfarbe pro Zeile (Decken-Muster: natives type="color" als Swatch).
     data-key -> state[c_names|c_meta|c_spruch|c_unten] -> render(). */
  function initColorPickers() {
    var pickers = root.querySelectorAll('.jg-color[data-key]');
    pickers.forEach(function (p) {
      p.addEventListener('input', function () {
        state[p.dataset.key] = p.value;
        render();
      });
    });
  }

  /* Papierfarbe (Poster-Hintergrund): Preset-Swatches (.jg-paper[data-color]) +
     freier Picker (.jg-paper-custom). -> state.bg_color -> render() + Payload.
     Server nutzt config.bg_color bereits. */
  function initPaperColor() {
    var swatches = root.querySelectorAll('.jg-paper[data-color]');
    var custom = root.querySelector('.jg-paper-custom');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      if (custom) custom.value = hex;
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
    if (custom) custom.addEventListener('input', function () { setPaper(custom.value); });
  }

  /* Namen-Schrift-Stil (Definitionsposter-Muster): 3-Wege-Umschalter.
     Wirkt NUR auf die Namen-Zeile. .current umsetzen -> state.name_style -> render(). */
  function initNameStyle() {
    var btns = root.querySelectorAll('.hauptwort-style-btn[data-style]');
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        btns.forEach(function (x) { x.classList.remove('current'); });
        b.classList.add('current');
        state.name_style = b.getAttribute('data-style') || 'elegant';
        render();
      });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help). Vanilla-Toggle:
     .tab-help__toggle blendet .tab-help__content ein/aus + .is-active am Toggle,
     .tab-help__close a blendet wieder aus. CSS kommt aus starmap.css. */
  function initTabHelp() {
    // ALLE Glühbirnen binden (Design- UND Produkt-Tab), Content = direkter Nachbar.
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* ===================================================================
   * Tabs (Text / Produkt) — main__switcher-Konvention (editor-tabs.css)
   * =================================================================== */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab — 1:1 Fotoposter/Wunschwort-Schema:
   * .tab__switcher a[data-id|data-type] schaltet .el__format + .benefits-box,
   * .size__picker a[data-size|data-variant-id] waehlt die Variante,
   * a[data-frame-color] die Rahmenfarbe (nur bei Holzrahmen sichtbar).
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  /* Stage-Proportion an die gewaehlte Groesse koppeln (immer Hochformat) —
     spiegelt den Server, der die aspect aus print.width/height ableitet. */
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.jg-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('jg-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  /* Holzrahmen-Vorschau: bei Typ "Poster im Holzrahmen" Frame an der Stage ein. */
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        // Groesse im neuen Format uebernehmen: gewuenschte behalten, sonst current/erste
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    // Initialzustand aus dem server-gerenderten Markup lesen
    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add — Muster wunschwort-poster.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * KEIN _preview_image_url, KEINE photo_slots/user_image_url.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('jg-cart-btn-' + sectionId);
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    if (!state.names || !state.names.trim()) { alert('Bitte gib die Namen des Brautpaars ein.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);

        var payload = {
          product: 'ja-geldgeschenk',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          bg_color: state.bg_color,
          word: state.word || 'Ja',
          names: state.names,
          date: state.date,
          ort: state.ort,
          spruch: state.spruch,
          untenzeile: state.untenzeile,
          cut_dash: !!state.cut_dash,
          name_style: state.name_style || 'elegant',
          c_names: state.c_names || INK,
          c_meta: state.c_meta || INK,
          c_spruch: state.c_spruch || INK,
          c_unten: state.c_unten || INK
        };

        // Render-Trigger (synchron). Fallback-URL deterministisch, falls Response leer.
        var printImageUrl = BACKEND_API_URL + '/api/v1/ja-geldgeschenk/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/ja-geldgeschenk/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend noch nicht live -> Fallback bleibt */ }

        var props = {
          '_Namen': state.names,
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_produkt': 'ja-geldgeschenk'
        };
        if (state.date && state.date.trim()) props['_Datum'] = state.date;
        if (state.ort && state.ort.trim()) props['_Ort'] = state.ort;
        // _Frame Color NUR bei Holzrahmen (exakte Schreibweise fuer Exporteo/Posterflow-SKU)
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        // theme.js-Listener erwarten detail.cart (sonst TypeError)
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[ja-geldgeschenk] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init
   * =================================================================== */
  function init() {
    root = document.querySelector('.jg-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('jg-stage-' + sectionId);

    // Defaults aus dem gerenderten Markup uebernehmen
    var f;
    if ((f = document.getElementById('input-namen'))) state.names = f.value;
    if ((f = document.getElementById('input-datum'))) state.date = f.value;
    if ((f = document.getElementById('input-ort'))) state.ort = f.value;
    if ((f = document.getElementById('input-spruch'))) state.spruch = f.value;
    if ((f = document.getElementById('input-untenzeile'))) state.untenzeile = f.value;
    if (root.dataset.word) state.word = root.dataset.word;
    var dash = document.getElementById('jg-dash-toggle');
    state.cut_dash = dash ? !!dash.checked : false;
    // Namen-Stil + Zeilen-Farben aus dem gerenderten Markup uebernehmen
    var activeStyle = root.querySelector('.hauptwort-style-btn.current[data-style]');
    if (activeStyle) state.name_style = activeStyle.getAttribute('data-style') || state.name_style;
    root.querySelectorAll('.jg-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
    });

    bindInputs();
    initPresetChips();
    initDashToggle();
    initColorPickers();
    initPaperColor();
    initNameStyle();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    // Nach Font-Load neu rendern -> Auto-Fit mit korrekten Metriken (Parlare/Playfair)
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('jg-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  // Fuer Isolationstests: Render-Bausteine exportieren (kein Effekt im Theme).
  if (typeof window !== 'undefined') {
    window.__jgTestApi = { jgText: jgText, buildHeart: buildHeart, JG_HEART_PATH: JG_HEART_PATH, INK: INK, BG: BG };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
